import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ElioHasPermissionModule } from '@elio/emanager-front/shared/directives';
import { SingleFilterOption } from '@elio/emanager-front/shared/models';
import { ElioButtonComponent } from '@elio/emanager-front/shared/ui/button';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective, PushPipe } from '@ngrx/component';
import { TooltipModule } from 'primeng/tooltip';
import { map } from 'rxjs';
import { FILTERABLE_STORE, FilterableStore, FilterableType } from '../../filter.token';

@Component({
  selector: 'elio-single-filter[filter]',
  templateUrl: './single-filter.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ElioButtonComponent,
    ElioHasPermissionModule,
    ElioSvgIconsModule,
    LetDirective,
    PushPipe,
    TooltipModule,
    TranslocoModule,
  ],
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElioSingleFilterComponent<T extends FilterableType> {
  @Input() filter!: SingleFilterOption<T>;
  @Input() hasTranslation = true;

  @Output() readonly onclick = new EventEmitter<void>();

  constructor(@Inject(FILTERABLE_STORE) private filterableStore: FilterableStore<T>) {}

  readonly isSelected$ = this.filterableStore.activeFiltersIds$.pipe(
    map((activeFiltersIds) => !!activeFiltersIds.find((activeFilterId) => activeFilterId === this.filter.id))
  );

  filterClick(selected: boolean): void {
    if (!selected) {
      this.filterableStore.enableFilter(this.filter.filterValue);
    } else {
      this.filterableStore.disableFilter(this.filter.filterValue);
    }
  }
}
